module.exports = __webpack_public_path__ + "static/media/2.Happy Face 2.0a3626bf.gif";